import { useQuery } from 'react-query';
import { getFCConfig, GetFCConfigResponse } from 'src/utils/Queries';

export function useFCConfig(fcName: string | undefined) {
    return useQuery<GetFCConfigResponse, Error>(
        ['fc-config', fcName],
        () => getFCConfig(fcName!)!,
        { enabled: !!fcName, staleTime: 300000 }
    );
}
